import type { Brand } from 'modules/client/types';
import { createEntityFilterChip } from './createEntityFilterChip';

export const BrandFilterChip = createEntityFilterChip('client/brands/', {
  getOptionLabel: (b: Brand) => b.title,
  getOptionValue: (b: Brand) => b.id.toString(),
});
